@if ((currentView$ | async); as currentView) {
  <filter-view-layout
    >
    <div filter-view-filter-bar>
      <div [formGroup]="form">
        <div class="filter-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_filter-by' | translate }}</mat-label>
            <mat-select
              formControlName="filterBy"
              disableOptionCentering
              data-cy="archive-filter-menu"
              panelClass="offsetPanel">
              @for (option of filterOptions$ | async; track option) {
                <mat-option
                  [attr.data-cy]="'archive-filter-' + option"
                  [value]="option">
                  {{ archiveFilterTranslations[option] | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        </div>
        <div class="sort-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_sort-by' | translate }}</mat-label>
            <mat-select
              formControlName="sortBy"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (option of sortByOptions; track option) {
                <mat-option
                  [value]="option">
                  {{ sortOrderTranslations[option] | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div filter-view-options-bar>
    @if (!UADetect.isMobile()) {
     <toggle-grid-list-view></toggle-grid-list-view>
    }
    </div>
    <div filter-view-content>
      @if ((archivedListDataSource.connect() | async)?.length && (archivedListDataSource.loading$ | async) ===  false) {
        @if (currentView === views.GRID) {
          <div class="grid-view">
            <archive-grid-view></archive-grid-view>
          </div>
        }
        @if (currentView === views.LIST) {
          <div class="list-view">
            <archive-table-view></archive-table-view>
          </div>
        }
      } @else {
        <archive-zero-state></archive-zero-state>
      }
    </div>
    <div filter-view-content-loading-bar>
      @if (archivedListDataSource.isLoadingMoreItems$ | async) {
        <div class="loading-bar-spinner"
          >
          <span class="ficon-spinner ficon-spin"></span>
        </div>
      }
    </div>
  </filter-view-layout>
}
